import { render, staticRenderFns } from "./DocLogo.vue?vue&type=template&id=7080289a&"
import script from "./DocLogo.vue?vue&type=script&lang=js&"
export * from "./DocLogo.vue?vue&type=script&lang=js&"
import style0 from "./DocLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports